import 'core-js';
import 'intersection-observer';
import "raf/polyfill";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom";
// import Raven from 'raven-js';

import "./index.less";
// import 'lib-flexible';
import '@utils/response';
import Router from "./router/router";
// import Console from 'vconsole';
// const vConsole = new Console();
// 
// Raven.config('https://427855b9536847eb874e450114e37623@sentry.zuowenzhitiao.com/13').install()

ReactDOM.render(
  <div id="container">
    <Router />
  </div>,
  document.getElementById("root")
);
